import ServiceGraphQL from 'src/service/gql-service';
import { getIndividual } from 'src/graphql';

const serviceGraphQL = new ServiceGraphQL();

/** Action creators */
export const GetIndividual = (variables) => {
  const params = {
    query: getIndividual.QUERY,
    variables
  };
  return serviceGraphQL
    .post(params)
    .then((res) => {
      return res.data.individualOne;
    })
    .catch((err) => {
      throw err;
    });
};
